import moment from 'moment';
import { ref } from 'vue';
import { projectFirestore } from '../firebase/config';
import store from '@/store';

const getTranslations = () => {
  const translations = ref([]);
  const isTranslationsLoading = ref(true);
  const translationError = ref(null);
  const fetchTranslation = async (library_key, defaultOnly = undefined) => {
    isTranslationsLoading.value = true;
    const hlpt_support_library_id = store.state.parent_lib_id;
    let categoryTitles = [];
    let articlesTitles = [];
    let defaultTransaltions = [];
    let customTranslations = [];
    let customDefaultTranslations = [];
    let searchArticlesTitles = [];
    categoryTitles = document.getElementsByClassName('category-title-link');
    articlesTitles = document.getElementsByClassName('category-articles-link');
    searchArticlesTitles = document.getElementsByClassName('search-articles-link');

    try {
      const fetchDefaultTranslations = () => {
        return new Promise((resolve, reject) => {
          if (hlpt_support_library_id) {
            projectFirestore
              .collection('Translations')
              .where('support_lib_id', '==', hlpt_support_library_id)
              .get()
              .then(snap => {
                if (!snap.empty) {
                  customDefaultTranslations = snap.docs.map(el => el.data());
                }
                resolve();
              });
          } else {
            resolve();
          }
        });
      };
      await projectFirestore
        .collection('SupportLibraries')
        .doc(library_key)
        .get()
        .then(async doc => {
          if (doc.exists) {
            if (window.generateDefaultTranslations) {
              defaultTransaltions = window.generateDefaultTranslations(doc.data());
            } else {
                // Fallback: wait a bit and try again
                setTimeout(() => {
                    if (window.generateDefaultTranslations) {
                      defaultTransaltionss = window.generateDefaultTranslations(doc.data());
                    } else {
                        console.warn('generateDefaultTranslations not available, using empty array');
                        defaultTransaltions = [];
                    }
                }, 100);
            }
            defaultTransaltions = [
              ...defaultTransaltions,
              { source: '__year', translation: moment().format('YYYY') },
              { source: '__month', translation: moment().format('MMMM') },
              { source: '__month_abv', translation: moment().format('MMM') },
              { source: '__day_number', translation: moment().format('D') },
              { source: '__day_english', translation: moment().format('dddd') }
            ];
          }
          await projectFirestore
            .collection('Translations')
            .where('support_lib_id', '==', library_key)
            .get()
            .then(async doc => {
              if (!doc.empty) {
                customTranslations = doc.docs.map(el => el.data());
              }

              await fetchDefaultTranslations();

              let sorted = [];

              if (defaultOnly !== undefined) {
                sorted = [...defaultTransaltions, ...customDefaultTranslations];
              } else {
                sorted = [...defaultTransaltions, ...customDefaultTranslations, ...customTranslations];
              }
              translations.value = _.uniqBy(_.reverse(_.clone(sorted)), 'source');
            });
        });
    } catch (err) {
      translationError.value = err;
    } finally {
      isTranslationsLoading.value = false;
    }
  };

  const translate = dataElement => {
    if (dataElement) {
      this.translations.forEach(elem => {
        const searchRegExp = new RegExp(`\\b${elem.source}\\b`, 'gi');
        dataElement = dataElement.toString().replaceAll(searchRegExp, elem.translation);
      });
    }
    return dataElement;
  };

  return {
    fetchTranslation,
    translations,
    translationError,
    isTranslationsLoading,
    translate,
  };
};

export default getTranslations;
